var requireGist = require.context('!!raw-loader!./gists');

requireGist.keys().map(function(key) {
    var name = key.match(/\w+/)[0];
    module.exports[name] = requireGist(key);
});
